import { DisplayDownloadExcelTimeCommand } from "src/app/shared/commands/display-download-excel-time-command";
import { FieldworkReportService } from "../../../services/fieldwork-report.service";
import { DownloadExcelCommand } from "../../../shared/commands/download-excel-command";
import { TextCol } from "../../records/models/columns/text-col";
import { TableStructure } from "../../records/models/table-structure";
import { FIELDWORK_CEC_COLUMNS } from "./fieldwork-cec-columns";
import { FIELDWORK_CEC_COLUMNS_MASE } from "./fieldwork-cec-columns-mase";
import { FIELDWORK_COLUMNS } from "./fieldwork-columns";
import { FIELDWORK_SALES_COLUMNS } from "./fieldwork-sales-columns";
import { FIELDWORK_SOL_DEL_COLUMNS } from "./fieldwork-sol-del-columns";
import { Fieldwork } from "./models/fieldwork";
import { IExcelDownloadTime } from "./models/excel-download-time";
import excelDownloadTimeData from "src/assets/estimated_fieldwork_time/excel_download_time.json";
const excelDownloadTimes: IExcelDownloadTime[] = excelDownloadTimeData as IExcelDownloadTime[];

export const genFieldworkTableConfig = (fieldWorkService: FieldworkReportService, isCec: boolean, isMase: boolean, isSalesSA: boolean, isSolOrDelivery: boolean, isElastic: boolean) => {
  let columns: TextCol<Fieldwork>[] = (isCec && isMase) ? FIELDWORK_CEC_COLUMNS_MASE :
    (isCec && !isMase) ? FIELDWORK_CEC_COLUMNS :
      isSalesSA ? FIELDWORK_SALES_COLUMNS :
        isSolOrDelivery ? FIELDWORK_SOL_DEL_COLUMNS :
          FIELDWORK_COLUMNS;

  if (!isElastic) {
    columns = columns.filter(col => col.columnDef !== 'discardType');
  }

  let commands = [
    new DisplayDownloadExcelTimeCommand<Fieldwork>(excelDownloadTimes),
    new DownloadExcelCommand<Fieldwork, FieldworkReportService>(fieldWorkService)
  ];
  if (isCec) {
    commands = [
      new DownloadExcelCommand<Fieldwork, FieldworkReportService>(fieldWorkService)
    ];
  }

  const FIELDWORK_TABLE_CONFIG: TableStructure<Fieldwork> = new TableStructure<Fieldwork>(
    columns
    ,
    "serverSide",
    undefined,
    { id: 'importedDate', start: 'desc', disableClear: true },
    false,
    [...commands]
    ,
    undefined,
    false
  );

  return FIELDWORK_TABLE_CONFIG;
};
